import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

export default function LevelProgressCard({ xp, level, levels, language, tProgress, tXpPoints, tXpToNext }) {
  const levelName = language === 'en' ? level.name_en : level.name_es;
  const xpInLevel = xp - level.min_xp;
  const xpRange = level.max_xp - level.min_xp;
  const progressPct = Math.min((xpInLevel / xpRange) * 100, 100);
  const nextLevel = levels?.find(l => l.min_xp > xp);
  const xpToNext = nextLevel ? nextLevel.min_xp - xp : 0;

  return (
    <Card className="rounded-xl overflow-hidden">
      <div className="h-2" style={{ background: level.color }} />
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center justify-between" style={{ fontFamily: 'Montserrat' }}>
          <span>{tProgress}</span>
          <span
            className="text-sm font-bold px-3 py-1 rounded-full"
            style={{ background: `${level.color}20`, color: level.color }}
          >
            {levelName}
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-end justify-between mb-2">
          <div>
            <span className="text-3xl font-black" style={{ fontFamily: 'Montserrat', color: level.color }}>{xp}</span>
            <span className="text-sm text-slate-400 ml-1">{tXpPoints}</span>
          </div>
          {nextLevel && (
            <span className="text-xs text-slate-400">{xpToNext} {tXpToNext}</span>
          )}
        </div>
        <Progress
          value={progressPct}
          className="h-3 rounded-full"
          style={{ '--progress-color': level.color }}
        />
        {levels && (
          <div className="flex justify-between mt-2">
            {levels.map(l => (
              <span
                key={l.min_xp}
                className={`text-[10px] font-medium ${xp >= l.min_xp ? 'text-slate-600' : 'text-slate-300'}`}
              >
                {language === 'en' ? l.name_en : l.name_es}
              </span>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
